import React, { forwardRef } from 'react';
import clsx from 'clsx';
import styles from './Input.module.css';

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  fullWidth?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  (
    {
      label,
      error,
      helperText,
      leftIcon,
      rightIcon,
      fullWidth = false,
      className,
      id,
      ...props
    },
    ref
  ) => {
    const inputId = id || `input-${Math.random().toString(36).substr(2, 9)}`;

    return (
      <div
        className={clsx(styles.container, { [styles.fullWidth]: fullWidth })}
      >
        {label && (
          <label htmlFor={inputId} className={styles.label}>
            {label}
            {props.required && <span className={styles.required}>*</span>}
          </label>
        )}

        <div className={clsx(styles.inputContainer, { [styles.error]: error })}>
          {leftIcon && <div className={styles.leftIcon}>{leftIcon}</div>}

          <input
            ref={ref}
            id={inputId}
            className={clsx(
              styles.input,
              {
                [styles.hasLeftIcon]: leftIcon,
                [styles.hasRightIcon]: rightIcon,
              },
              className
            )}
            {...props}
          />

          {rightIcon && <div className={styles.rightIcon}>{rightIcon}</div>}
        </div>

        {(error || helperText) && (
          <div className={styles.helperContainer}>
            {error && <span className={styles.errorText}>{error}</span>}
            {helperText && !error && (
              <span className={styles.helperText}>{helperText}</span>
            )}
          </div>
        )}
      </div>
    );
  }
);
